import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="Footer">
        <p>CopyRight &copy; 2025 POS System, All Right Reserved.</p>
        <p>
          Developed by :{" "}
          <Link to="https://nyatapol.com/" target="_blank">
            Nyatapol Technologies
          </Link>
        </p>
      </div>
    </>
  );
}

export default Footer;
